import React, { useState } from "react";
import Sidebar from "./Sidebar";
import "./Layout.css";

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleSidebarToggle = (isOpen) => {
    setSidebarOpen(isOpen);
  };

  return (
    <div className="layout">
      <Sidebar onToggle={handleSidebarToggle} />
      <div className={`layout-content ${sidebarOpen ? "shifted" : ""}`}>
        <main className="layout-main">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
